// API
import { get } from "./api";
// Constants
import { APP_LOGO, THEME_STYLE } from "../config/constants";

export const fetchAppFeatureSettings = () => async (dispatch) => {
  try {
    const { data } = await dispatch(get("/appFeatureSettings"));

    const hasActiveVoucherSystem = data.hasActiveVoucherSystem;
    const hasActivePayment = data.hasActivePayment;
    const enableUserDataEdit = data.enableUserDataEdit;

    return {
      hasActiveVoucherSystem,
      hasActivePayment,
      enableUserDataEdit
    };
  } catch (error) {
    return {
      hasActiveVoucherSystem: true,
      hasActivePayment: false,
      enableUserDataEdit: true
    };
  }
};

function setClientLogoOnLocalStorage({ appLogo }) {
  return localStorage.setItem(APP_LOGO, appLogo);
}

function setThemeStyleOnLocalStorage({ designThemeStyle }) {
  return localStorage.setItem(THEME_STYLE, designThemeStyle);
}

export const fetchClientLogo = () => async (dispatch) => {
  try {
    const { data } = await dispatch(get("/appDesignSettings"));

    const appLogo = data.applicationLogo || require("../assets/img/logo.png");
    const backgroundImg = data.loginSiteBackGroundPicture || require("../assets/img/fallbackBackgroundImage.png");
    const loginLogo = data.loginSiteLogo || require("../assets/img/fallbackLoginLogo.png");
    const loginLogoPosition = data.loginSiteLogoPosition || "center";
    const designThemeStyle = data.themeStyle || "Light";

    setClientLogoOnLocalStorage({
      appLogo
    });

    setThemeStyleOnLocalStorage({
      designThemeStyle
    });

    return {
      backgroundImg,
      loginLogo,
      loginLogoPosition,
      designThemeStyle
    };
  } catch (error) {
    setClientLogoOnLocalStorage({
      appLogo: require("../assets/img/logo.png")
    });

    setThemeStyleOnLocalStorage({
      designThemeStyle: "Light"
    });

    return {
      backgroundImg: require("../assets/img/fallbackBackgroundImage.png"),
      loginLogo: require("../assets/img/fallbackLoginLogo.png"),
      loginLogoPosition: "center",
      designThemeStyle: "Light"
    };
  }
};
